const state = {
  payStatusLabels: {
    unpaid: ['未付款', 'unpaid-color white--text pa-1'],
    paying: ['待確認', 'amber white--text pa-1'],
    paid: ['已付款', 'green white--text pa-1'],
    refunding: ['退款中', 'brown lighten-2 white--text pa-1'],
    refunded: ['已退款', 'refunded-color white--text pa-1']
  },
  statusLabels: {
    frozen: ['已凍結', 'pink white--text pa-1'],
    normal: ['待處理', 'light-blue white--text pa-1'],
    dealt: ['已處理', 'blue white--text pa-1'],
    confirming: ['交易結果待確認', 'light-green white--text pa-1'],
    traded: ['交易成功', 'green white--text pa-1'],
    failed: ['交易失敗', 'brown white--text pa-1'],
    closed: ['交易關閉', 'grey white--text pa-1']
  },
  jyStatusLabels: {
    unpacked: ['已下單', 'unpacked-color white--text pa-1'],
    prepare: ['備貨中', 'blue white--text pa-1'],
    packing: ['打包中', 'red white--text pa-1'],
    packed: ['已打包', 'packed-color white--text pa-1'],
    depacked: ['取消出貨', 'refunded-color white--text pa-1'],
    shipped: ['已出貨', 'shipped-color white--text pa-1'],
    received: ['已簽收', 'received-color white--text pa-1'],
    returned: ['清關失敗', 'red white--text pa-1']
  },
  createFormData: {
    cneeAddrid: '',
    multiCneesAddrids: [],
    needAddrNum: 1, // 地址多选时需要的地址数量
    csType: '' // 配送方式
  },
  totalCount: 0, // 訂單數量
  showOrderDialogData: {
    show: false,
    showPay: false,
    oid: '',
  },
}

const getters = {
  jyProgress: (state, getters) => (order, separator = '') => {
    const payStatusLabel = getters.payStatusLabel(order.payStatus)
    const statusLabel = getters.statusLabel(order.status)
    const jyStatusLabel = getters.jyStatusLabel(order.jyStatus)

    if (order.payStatus === 'unpaid') {
      return order.status === 'closed' ? `${statusLabel}` : `${payStatusLabel}`
    } else if (order.payStatus === 'refunded') {
      return `${payStatusLabel}`
    } else if (order.payStatus === 'paid') {
      return jyStatusLabel
    } else if (order.status === 'closed') {
      return `${statusLabel}`
    }
    return `${payStatusLabel} ${separator} ${jyStatusLabel}`
  },
  statusStepper: (state, getters) => (order) => {
    const payStatusLabel = getters.payStatusLabel(order.payStatus)
    const statusLabel = getters.statusLabel(order.status)
    const packingLabel = getters.packingLabel(order.jyPackingAt)

    if (order.payStatus === 'unpaid' && order.status !== 'closed') {
      return ` ${payStatusLabel}`
    } else if (order.status === 'closed') {
      return `${statusLabel}`
    }
    return `${statusLabel} ${payStatusLabel} ${packingLabel}`
  },
  payStatusLabel: (state) => (payStatus) => {
    const label = state.payStatusLabels[payStatus]
    return `<span class="${label[1]}">${label[0]}</span>`
  },
  statusLabel: (state) => (status) => {
    const label = state.statusLabels[status]
    return `<span class="${label[1]}">${label[0]}</span>`
  },
  jyStatusLabel: (state) => (jyStatus) => {
    const label = state.jyStatusLabels[jyStatus]
    return `<span class="${label[1]}">${label[0]}</span>`
  },
  packingLabel: (state) => (jyPackingAt) => {
    return jyPackingAt === '0000-00-00 00:00:00'
      ? '<span class="red--text">等待集運商打包</span>'
      : '<span class="green--text darken-5">集運商已打包</span>'
  }
}

const mutations = {
  setCud (state, value) {
    state.isCud = value
  },
  setCreateFormData (state, value) {
    state.createFormData = value
  },
  setTotalCount (state, value) {
    state.totalCount = value
  },
  setShowOrderDialogData (state, value) {
    state.showOrderDialogData = {
      show: true,
      showPay: false,
      oid: '',
      ...value
    }
  }
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/order/index', { params })
  },
  prepareParcels ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/order/prepare-parcels', params)
  },
  createJy ({ state, commit, rootState }, params) {
    params.mchAccessToken = localStorage.getItem('mchAccessToken')
    return rootState.axios.post('/jyb/v1frontend/order/create-jy', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/order/view', { params })
  },
  payByPaybaoRcoin ({ state, commit, rootState }, params) {
    params.mchAccessToken = localStorage.getItem('mchAccessToken')
    return rootState.axios.post('/jyb/v1frontend/order/pay-by-paybao-rcoin', params)
  },
  updateJyClosed ({ state, commit, rootState }, params) {
    params.mchAccessToken = localStorage.getItem('mchAccessToken')
    return rootState.axios.post('/jyb/v1frontend/order/update-jy-closed', params)
  },
  updateJyReceived ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/order/update-jy-received', params)
  },
  updateBizRate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/order/update-biz-rate', params)
  },
  updatePush ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/order/update-push', params)
  },
  fetchTotalCount ({ state, commit, dispatch }) {
    return dispatch('index', {
      page: 1,
      pageSize: 1,
      isTotalCount: 1
    }).then(res => {
      commit('setTotalCount', res.data.listInfo.totalCount)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
